.split-offer-selected-tag {
  position: relative;

  .tag-text {
    color: white;
    z-index: 1;
    font-size: 14px;
    font-weight: 500;
    line-height: 15.4px;
    text-align: left;
    position: absolute;
    margin-left: 6px;
    vertical-align: middle;
    top: 1px;
  }

  svg {
    left: -12px;
    position: absolute;
    top: -5px;

    width: 129px;
    height: 35px;
  }

  &.fr {
    svg {
      left: -13px;
      width: 159px;
      height: 42px;
    }
  }
}
